import { useState, useEffect } from 'react'
import { useLazyQuery } from '@apollo/react-hooks'
import DocumentQuery from '../../queries/DocumentQuery'

const POLLING_INTERVAL = 5000
const POLLING_MAX_TRIES = 10

function useEsignDraftPoll(documentId, isDraft) {
  const [pollingCount, setPollingCount] = useState(0)

  const [query, { data, stopPolling }] = useLazyQuery(DocumentQuery, {
    fetchPolicy: 'network-only',
    pollInterval: isDraft ? POLLING_INTERVAL : 0,
    variables: {
      rid: documentId,
    },
  })

  useEffect(() => {
    if (isDraft) query()
  }, [isDraft])

  useEffect(() => {
    if (pollingCount > POLLING_MAX_TRIES) {
      stopPolling()
    } else {
      setPollingCount((prev) => prev + 1)
    }
  }, [data, stopPolling])
}

export default useEsignDraftPoll
